import React from 'react';

import { Resolver } from 'craft/types';

import { RTENode } from '../RTENode';

export const ListItem: Resolver = (props: any) => {
  return <RTENode is="li" {...props} />;
};
